<nav class="navbar navbar-expand-lg navbar-light bg-light text-center">
    <a class="navbar-brand" href="/"><img src="assets/images/logo.png" /></a>
</nav>
<div class="row">
    <div class="container">
        <div class="cols mt-5 public-data">
            <div [innerHTML]="privacyData.content"></div>
        </div>
    </div>
</div>